import { t } from 'i18next'
import React from 'react'
import { Button, ButtonGroup, Modal, ModalBody, ModalHeader } from 'reactstrap'

const Logout = ({ isLogoutOpen, setIsLogoutOpen }) => {
    const logOut = async () => {
        localStorage.clear()
        window.location.href = '/login'
    }

    return (
        <Modal isOpen={isLogoutOpen} toggle={() => setIsLogoutOpen(!isLogoutOpen)} centered size="sm">
            <ModalHeader className='border-0' toggle={() => setIsLogoutOpen(!isLogoutOpen)}></ModalHeader>
            <ModalBody>
                <div className='text-center'>
                    <h5>{t("logout")}</h5>
                    
                    <p className='color3'>{t("logout_text")}</p>
                    <div className='d-flex justify-content-center'>
                        <ButtonGroup>
                            <Button color='danger' onClick={logOut}>{t("yes")}</Button>
                            <Button className='border border-danger' color='transparent' onClick={() => setIsLogoutOpen(!isLogoutOpen)}>{t("no")}</Button>
                        </ButtonGroup>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default Logout
